export default function useReleaseDate(
  productReleaseDate: string | undefined
): boolean {
  const releaseDate = Number(productReleaseDate)

  const currentDate = Date.now()

  const deadlineInMilliseconds = 4060800000 // 47 days

  return currentDate - releaseDate <= deadlineInMilliseconds
}
